import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-label small mb-1" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-label small mb-1" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-label small mb-1" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-label small mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createVNode(_component_localized_text, {
          localizedKey: "Prezzo iniziale",
          text: "Prezzo iniziale"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.fullPrice) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.fullPrice]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Prezzo finale",
          text: "Prezzo finale"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.finalPrice) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.finalPrice]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _createVNode(_component_localized_text, {
          localizedKey: "Valuta",
          text: "Valuta"
        })
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.currency) = $event))
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("option", { value: "€" }, "€", -1),
        _createElementVNode("option", { value: "AuraCoin" }, "AuraCoin", -1)
      ]), 512), [
        [_vModelSelect, _ctx.localValue.currency]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, [
        _createVNode(_component_localized_text, {
          localizedKey: "Note",
          text: "Note"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        class: "form-control",
        type: "text",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.note) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.note]
      ])
    ])
  ], 64))
}